import React from "react";
import { Link, useNavigate } from 'react-router-dom'

const AddSchoolProfile = () =>{

    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/school_profile_list")
        
    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">
			
            <div className="page-title-wrpr">
                <div className="page-title-left-column">
                    
                    <h2 className="page-title">Add School Profile</h2>
                </div>
                <div className="page-rightside-action-column">
                    
                    
                </div>
                
                
            </div>
            
            
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/school_profile_list">School Profile</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add School Profile</li>
              </ol>
            </nav>
            <div className="form-wrpr">
                <div className="card formcard small">
                    <div className="card-body">
                        <div className="form-group">
                            <label className="degreehead">School Profile</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" placeholder="Enter School Name" id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">Address</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" placeholder="Enter Address" id="name"></input>
                        </div>
                        <div className="form-group">
                            <label className="degreehead">City</label>
                            <input type="text" className="form-control bg-dark dark-theme showtext" placeholder="Enter City" id="name"></input>
                        </div>
                        
                        <div className="form-group text-right">
                        <button className="btn btn-danger btn-gisa" onClick={RoutToList} type="submit">Cancel</button>
                            <button className="btn btn-primary btn-gisa" type="submit">Add Links</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
            </aside>
        </div>
    )
}

export default AddSchoolProfile;